// Vehicle edit dialog panel layout config over the reusable panel-grid base.
import { type PanelGridConfig } from '@/common/panelGrid/panelGridLayout';

export type VehicleDialogPanelId =
  | 'identity'
  | 'preview'
  | 'type'
  | 'movement'
  | 'keybindings';

export const vehicleDialogStorageKey = 'vehicle-dialog-grid-layout';

export const vehicleDialogGridConfig: PanelGridConfig = {
  schemaVersion: 4,
  columns: 12,
  cellHeight: 34,
  margin: 6,
  collapsedRows: 1,
  window: {
    defaultWidth: 1200,
    defaultHeight: 840,
    minWidth: 900,
    minHeight: 560,
    maxWidth: 3840,
    maxHeight: 2160,
  },
  label: {
    default: 176,
    min: 64,
    max: 480,
  },
  panelOrder: ['identity', 'preview', 'type', 'movement', 'keybindings'],
  placements: {
    identity: { x: 0, y: 0, w: 4, h: 12 },
    preview: { x: 4, y: 0, w: 4, h: 20 },
    type: { x: 0, y: 12, w: 4, h: 12 },
    movement: { x: 8, y: 0, w: 4, h: 14 },
    keybindings: { x: 0, y: 24, w: 12, h: 14 },
  },
};
